export enum ELoginType {
  PHONE = 'phone',
  EMAIL = 'email',
}

export enum ELoginMethod {
  OTP = 'otp',
  PWD = 'password',
}

export enum ESignUpProfileStep {
  PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
  BUSINESS_INFORMATION = 'BUSINESS_INFORMATION',
  STATION_LOCATION = 'STATION_LOCATION',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
}

export const OTP_LENGTH = 6;
export const OTP_RESEND_COOL_DOWN = 30;

export const PROFILE_REDIRECT_TIMEOUT = 1500;
